<template>
  <transition name="loading">
    <div v-if="loading" class="loading">
      <LoadingPadraoContainer
        background
        :fraseLoading="['Gerando relatório', 'Aguarde um momento']"
        delay="5000"
        classe="azul"
      />
    </div>
  </transition>
</template>

<script>
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "ModalImpressaoLoading",
  components: {
    LoadingPadraoContainer
  },
  props: {
    loading: Boolean
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";

.loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: #00000049;
  color: var(--branco);
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-size: 50px;
  }
}
.loading-enter-active,
.loading-leave-active {
  transition: all 0.1s ease;
}
.loading-enter,
.loading-leave-to {
  opacity: 0;
}
</style>
